import * as React from 'react';
const Home = ({ fill = 'none', stroke = '#505A62', className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={27.642} height={24.396}>
    <path
      fill={stroke}
      d="M0 11.481a1 1 0 0 0 1.057.989 1.376 1.376 0 0 0 .863-.391l11.482-9.676a.614.614 0 0 1 .875 0l11.458 9.68a1.405 1.405 0 0 0 .863.391.961.961 0 0 0 1.045-.952 1.024 1.024 0 0 0-.377-.842l-3.232-2.727V3.278a.774.774 0 0 0-.826-.83h-1.337a.783.783 0 0 0-.838.83v2.136L15.298.568a2.156 2.156 0 0 0-2.916 0L.402 10.675a1.022 1.022 0 0 0-.402.806Zm3.633 10.327a2.4 2.4 0 0 0 2.637 2.588h15.122a2.4 2.4 0 0 0 2.629-2.588v-9.033l-9.5-8a1 1 0 0 0-1.385 0l-9.5 8Zm13.171.586h-5.966v-7.58a.828.828 0 0 1 .887-.879h4.192a.828.828 0 0 1 .887.879Z"
    />
  </svg>
);
export default Home;
